import { field, validationTypes } from 'components/FormCreatorComponent/types';
import { INewAccount, accountMaxForPaymentAndConvert, newAccountsSteps } from 'constants/new_accounts.constants';
import { getDate, getMonth, getYear, isValid } from 'date-fns';
import _ from 'lodash';
import { newAccountTypesForms } from 'sections/NewAccounts/forms.types';

export const getTabTitle = (t: any, step: newAccountsSteps, newAccount: INewAccount | undefined) => {
	return step === newAccountsSteps.CUSTOMER_DETAILS
		? `${t('page.accounts.new_account.customer_details.first_step.title')}` +
				`${newAccount?.accountNameHebrew ? ` | ${newAccount?.accountNameHebrew}` : ''}`
		: step === newAccountsSteps.USER_DETAILS
		? t('page.accounts.new_account.customer_details.title')
		: step === newAccountsSteps.BANK_ACCOUNT_DETAILS
		? t('page.accounts.new_account.customer_details.account_details.title')
		: t('page.accounts.new_account.conclusion.title');
};

export const prepareInitialValues = (_formValues: Record<string, any>) => {
	const _initialValues: Record<string, any> = {};
	const forms = _.get(newAccountTypesForms, newAccountsSteps.USER_DETAILS);
	forms.map((form) => {
		form.fieldsGroups.map((group) => {
			group.fields.map((field) => {
				let value = _.get(_formValues, field.props.name, '');
				value = _.isNull(value) || _formValues.id === 'new' ? '' : value;
				switch (field.props.name) {
					case 'day':
						value = isValid(new Date(_formValues.dateOfBirth))
							? String(getDate(new Date(_formValues.dateOfBirth)))
							: '';
						break;
					case 'month':
						value = isValid(new Date(_formValues.dateOfBirth))
							? String(getMonth(new Date(_formValues.dateOfBirth)))
							: '';
						break;
					case 'year':
						value = isValid(new Date(_formValues.dateOfBirth))
							? String(getYear(new Date(_formValues.dateOfBirth)))
							: '';
						break;
				}
				_.assign(_initialValues, {
					[field.props.name]: value,
				});
			});
		});
	});
	return _initialValues;
};

export const prepareBankAccountInitialValues = (_formValues: Record<string, any>) => {
	const _initialValues: Record<string, any> = {};
	const forms = _.get(newAccountTypesForms, newAccountsSteps.BANK_ACCOUNT_DETAILS);
	forms.map((form) => {
		form.fieldsGroups.map((group) => {
			group.fields.map((field) => {
				let value = _.get(_formValues, field.props.name, '');
				value = _.isNull(value) || _formValues.id === 'new' ? '' : value;
				//const value = newBankAccount.id === 'new' ? '' : _.get(newBankAccount, field.props.name, '');
				_.assign(_initialValues, {
					[field.props.name]: value,
				});
			});
		});
	});
	return _initialValues;
};

export const getHelperText = (newAccount: INewAccount, step: newAccountsSteps, field: field, t: any) => {
	if (_.isEqual(step, newAccountsSteps.USER_DETAILS)) {
		if (_.includes(['maxForPayment', 'maxForConvert'], field.props.name)) {
			return _.replace(t('label.maxAmount'), '{0}', _.get(newAccount, field.props.name, 0).toLocaleString());
		}
	}
	if (_.isEqual(step, newAccountsSteps.CUSTOMER_DETAILS)) {
		if (_.includes(['maxForPayment', 'maxForConvert'], field.props.name)) {
			return _.replace(t('label.maxAmount'), '{0}', accountMaxForPaymentAndConvert.toLocaleString());
		}
	}
	return '';
};

export const getValidation = (
	newAccount: INewAccount,
	step: newAccountsSteps,
	field: field,
	coinWithDecimalNotAllowedChosen = false
) => {
	const initialValidation = field.validation || [];
	if (_.isEqual(step, newAccountsSteps.USER_DETAILS)) {
		if (_.includes(['maxForPayment', 'maxForConvert'], field.props.name)) {
			return [...initialValidation, { maxNumber: _.get(newAccount, field.props.name, 0) }];
		}
	}

	if (_.includes(field.props.name, 'amount')) {
		if (coinWithDecimalNotAllowedChosen) {
			return [{ [validationTypes.noDecimalAllowed]: true }, { [validationTypes.requierd]: true }];
		} else {
			return [{ [validationTypes.integer]: true }, { [validationTypes.requierd]: true }];
		}
	}
	return field.validation || [];
};
